import { Renew } from '@carbon/icons-react';
import type { ReactNode } from 'react';
import { CdButton } from '../../atoms/CdButton';
import { CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdResultMeta.module.scss';

export interface CdResultMetaProps {
  /** e.g. "200 records. Last checked: 09/27/2026 1:31 PM" */
  summary: string;
  onRefresh?: () => void;
  refreshLabel?: string;
  /** Extra actions on the right (e.g. Manage columns menu). */
  actions?: ReactNode;
  className?: string;
}

export const CdResultMeta = ({
  summary,
  onRefresh,
  refreshLabel = 'Refresh',
  actions,
  className,
}: CdResultMetaProps) => {
  return (
    <div className={cx(styles.root, className)}>
      <CdText variant="small" tone="secondary" role="status" aria-live="polite">
        {summary}
      </CdText>
      <div className={styles.actions}>
        {onRefresh && (
          <CdButton variant="ghost" size="sm" icon={Renew} onClick={onRefresh}>
            {refreshLabel}
          </CdButton>
        )}
        {actions}
      </div>
    </div>
  );
};
